const NotFound = () => {
  return (
    <>
      <div className="mx-auto h-full w-full">
        <h1>Page Not Found</h1>
      </div>
    </>
  )
}
export default NotFound;